var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyTypeHb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 13.05h-.05L3 12.3V9c.05-.1 1-2.3 2.9-2.6 1.7-.3 4.95-.95 5.3-1l8.75-3.9H32.4l.05.05c.1.1 2.85 1.9 3.3 5.8l1.1 1.5v2c-.05.05-.7 1.7-3.35 1.7-.15 0-.25-.1-.25-.25s.1-.25.25-.25c2.1 0 2.75-1.1 2.85-1.35V9l-1.1-1.5v-.05c-.35-3.4-2.65-5.2-3-5.5H20L11.35 5.8c-.05 0-3.55.75-5.35 1-1.5.25-2.35 1.95-2.5 2.3v2.7l2.85.65c.15.05.2.15.2.3 0 .2-.1.3-.25.3z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 13.05H13.6c-.15 0-.25-.1-.25-.25s.1-.25.25-.25h12.5c.15 0 .25.1.25.25s-.1.25-.25.25z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 14.65c-1.6 0-2.85-1.3-2.85-2.85s1.3-2.85 2.85-2.85 2.85 1.3 2.85 2.85-1.3 2.85-2.85 2.85zm0-5.2c-1.3 0-2.35 1.05-2.35 2.35s1.05 2.35 2.35 2.35 2.35-1.05 2.35-2.35-1.05-2.35-2.35-2.35zM10.2 14.65c-1.6 0-2.85-1.3-2.85-2.85s1.3-2.85 2.85-2.85 2.85 1.3 2.85 2.85-1.25 2.85-2.85 2.85zm0-5.2c-1.3 0-2.35 1.05-2.35 2.35s1.05 2.35 2.35 2.35 2.35-1.05 2.35-2.35-1.05-2.35-2.35-2.35z",
    fill: "#10B1D7"
  })));
}
export default SvgBodyTypeHb;